import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import PseudoSelect from './pseudo-select';

class Component extends BaseComponent {
    render({logged_in, state_upc, upc, packages, sale_price_code}) {
        let ga_label = 'logged-out';
        if (logged_in) {
            ga_label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        if (packages) {
            return (
                <power-package>
                    <div class='small-2 columns'>
                        <input
                          type='radio'
                          name='upc'
                          value={upc}
                          onClick={(e) => this.trackChange(e, ga_label)}
                          checked={state_upc == upc}
                        />
                        <div class='pseudo-radio' />
                    </div>
                    <div class='small-10 medium-9 columns'>
                        <label>
                            <select
                              active={state_upc == upc}
                              onChange={(e) => this.trackChange(e, ga_label)}
                              onFocus={(e) => this.trackFocus(e, ga_label)}
                            >
                                { packages.map((pkg) => (this.renderOption(pkg, state_upc, upc))) }
                            </select>
                            <PseudoSelect />
                        </label>
                    </div>
                </power-package>
            );
        }

        return (
            <power-package />
        );
    }

    renderOption(pkg, state_upc, upc) {
        return (
            <option value={pkg.upc} selected={pkg.upc == upc}>
                {pkg.free_kcs + pkg.paid_kcs} Karma Coins - ${pkg.usd.current}
            </option>
        );
    }

    trackChange(e, ga_label) {
        this.props.trackChange(e.target.value, ga_label);
        this.props.setPowerUPC(e.target.value);
    }

    trackFocus(e, ga_label) {
        this.props.trackFocus(ga_label);
        this.props.setPowerUPC(e.target.value);
    }

    setPowerValue(e) {
        this.props.setPowerUPC(e.target.value);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    state_upc: state['karmacoin-store'].upc,
    upc: state['karmacoin-store'].power_upc,
    packages: state['karmacoin-store'].packages && state['karmacoin-store'].packages.power,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

const mapDispatchToProps = (dispatch) => ({
    trackChange: (upc, ga_label) => dispatch({
        type: 'ga:event',
        payload: [
            'kc-store',
            'Click-' + upc,
            ga_label,
        ],
    }),
    trackFocus: (ga_label) => dispatch({
        type: 'ga:event',
        payload: [
            'kc-store',
            'Reveal-Power-Packages',
            ga_label,
        ],
    }),
    setPowerUPC: (upc) => dispatch({ type: 'karmacoin-store:power_upc', payload: upc }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/power-package.js